import { STEPS, countErrorsForStep } from './STEPS';
import Icon from './shared/Icon';

/**
 * @param {{
 *   currentStepIdx: number,
 *   onStepClick: (i: number) => void,
 *   errors: Array<{field?: string, severity?: string}>,
 * }} props
 */
export default function ClaimStepper({ currentStepIdx, onStepClick, errors }) {
  return (
    <nav aria-label="Claim creation steps" style={{
      display: 'flex', alignItems: 'center', gap: 0,
      padding: '14px 24px',
      background: 'var(--ab-bg)',
      borderBottom: '1px solid var(--ab-border-hair)',
      overflowX: 'auto',
    }}>
      {STEPS.map((step, i) => {
        const done = i < currentStepIdx;
        const current = i === currentStepIdx;
        const errCount = countErrorsForStep(errors, step);
        const showError = errCount > 0 && !current;
        const border = showError ? 'var(--ab-denied)' : (current || done ? 'var(--ab-fg)' : 'var(--ab-border-hair)');
        const fill   = (done || current) ? 'var(--ab-fg)' : 'var(--ab-bg)';
        const fg     = (done || current) ? 'var(--ab-fg-inverse)' : (showError ? 'var(--ab-denied)' : 'var(--ab-fg-subtle)');
        const labelColor = current ? 'var(--ab-fg)' : showError ? 'var(--ab-denied)' : (done ? 'var(--ab-fg)' : 'var(--ab-fg-subtle)');
        return (
          <div key={step.key} style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
            <button
              type="button"
              onClick={() => onStepClick(i)}
              aria-current={current ? 'step' : undefined}
              style={{
                display: 'inline-flex', alignItems: 'center', gap: 10,
                padding: '6px 4px',
                background: 'transparent', border: 'none', cursor: 'pointer',
              }}
            >
              <span
                data-step-error={showError ? 'true' : undefined}
                style={{
                  width: 28, height: 28, borderRadius: '50%',
                  border: `1.5px solid ${border}`,
                  background: fill, color: fg,
                  display: 'grid', placeItems: 'center',
                  fontSize: 12, fontWeight: 'var(--ab-weight-bold)',
                }}
              >
                {done ? <Icon name="check" size={13} /> : i + 1}
              </span>
              <span style={{
                fontSize: 13, fontWeight: current ? 'var(--ab-weight-bold)' : 'var(--ab-weight-medium)',
                color: labelColor, whiteSpace: 'nowrap',
              }}>
                {step.label}
              </span>
            </button>
            {i < STEPS.length - 1 && (
              <div style={{
                flex: 1, height: 1, minWidth: 20, margin: '0 12px',
                background: i < currentStepIdx ? 'var(--ab-fg)' : 'var(--ab-border-hair)',
              }} />
            )}
          </div>
        );
      })}
    </nav>
  );
}
